import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import AdminHeader from './AdminHeader';

const AdminDashboard = () => {
    console.log("AdminDashboard rendu");
    return (
        <div className="flex h-screen bg-gray-100">
            {/* Sidebar */}
            <div className="w-64 bg-[#3D5A80]">
                <Sidebar />
            </div>

            <div className="flex-1 flex flex-col overflow-hidden">
                <AdminHeader />

                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100">
                    <div className="container px-6 py-8 mx-auto">
                        {/* Important: l'Outlet permet d'afficher les routes enfants */}
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default AdminDashboard;